import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams, Link } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

const ProductDetailsPage = () => {
  const { brandName, itemName } = useParams(); // Access both brandName and itemName from the URL

  const hasLoadedScripts = useRef(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isService, setIsService] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [item, setItem] = useState(null);
  const [category, setCategory] = useState(null);
  const [pdfExists, setPdfExists] = useState(false);
  const [jpgExists, setJpgExists] = useState(false);

  const Head = () => {
    return (
      <Helmet>
        <title>
          STAR TECH | {brandName} | {itemName}
        </title>
      </Helmet>
    );
  };

  const addToEnquiryList = () => {
    // const itemName = "YourItemName"; // Replace with your actual item name
    const storedData = localStorage.getItem("enquiryList");

    let enquiryList = storedData ? JSON.parse(storedData) : {};

    // Update the quantity for the item
    if (enquiryList[itemName]) {
      enquiryList[itemName] += quantity;
    } else {
      enquiryList[itemName] = quantity;
    }

    // Save back to localStorage
    localStorage.setItem("enquiryList", JSON.stringify(enquiryList));
    alert("Added item to enquiry list.");
    console.log("Added to enquiry list:", enquiryList);
  };

  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    const scripts = [
      // Add other script paths here...
      "/js/jquery.js",
      "/js/popper.min.js",
      "/js/bootstrap.min.js",
      "/js/jquery.fancybox.js",
      "/js/jquery-ui.js",
      "/js/jquery.countdown.js",
      "/js/bxslider.js",
      "/js/mixitup.js",
      "/js/wow.js",
      "/js/appear.js",
      "/js/select2.min.js",
      "/js/swiper.min.js",
      "/js/owl.js",
      "/js/script.js",
    ];

    const loadScripts = async () => {
      if (!hasLoadedScripts.current) {
        try {
          for (const script of scripts) {
            await loadScript(script);
          }
          hasLoadedScripts.current = true; // Mark as loaded
          console.log("All scripts loaded successfully");
        } catch (error) {
          console.error("Error loading scripts", error);
        }
      }
    };

    loadScripts();
    setTimeout(() => {
      setIsLoaded(true);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 1500);

    console.log(brandName);
    console.log(brandName.brandName);
    console.log(itemName);
    const fetchData = async () => {
      try {
        const response = await fetch("../../products.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        const findItem = data.products.find(
          (product) => product.name === itemName
        );
        console.log(findItem);
        if (findItem) {
          setItem(findItem);
          const findCategory = data.categories.find(
            (category) => category.id === findItem.category_id
          );
          setCategory(findCategory);
          if (findItem.quantity === true) {
            setIsService(false);
          }
        } else {
          console.error("Item not found");
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    const checkPdfExists = async () => {
      if (!itemName) return;

      try {
        const response = await fetch(
          `/pdfs/Datasheets/${brandName}/${itemName}.pdf`,
          {
            method: "HEAD",
          }
        );
        console.log("Response:", itemName);
        console.log("PDF exists:", response);
        const isPdf = response.headers
          .get("Content-Type")
          ?.includes("application/pdf");
        console.log("Is PDF:", isPdf);
        setPdfExists(response.ok && isPdf);
      } catch (error) {
        console.error("Error checking PDF existence:", error);
        setPdfExists(false);
      }
    };

    const checkJpgExists = async () => {
      if (!itemName) return;

      try {
        const response = await fetch(
          `/pdfs/Datasheets/${brandName}/${itemName}.jpg`,
          {
            method: "HEAD",
          }
        );
        setJpgExists(response.ok);
      } catch (error) {
        setJpgExists(false);
      }
    };

    fetchData();
    checkPdfExists(); // Check if the PDF exists
    checkJpgExists(); // Check if the JPG exists
  }, []);

  return (
    <>
      <Head />
      <div className="page-wrapper">
        {/* <!-- Preloader --> */}
        {!isLoaded && <div className="preloader"></div>}
        <Header selection="products" />
        {/* <!--Product Details Start--> */}
        <section className="product-details">
          <div className="container pb-70">
            <div className="row">
              <div className="col-lg-6 col-xl-6">
                <div className="bxslider" style={{ zIndex: 0 }}>
                  <div className="slider-content">
                    <figure className="image-box">
                      <a
                        href={`./../../images/products/${item?.name
                          .replace(/\//g, "-")
                          .replace(/\*/g, "-")}.jpg`}
                        className="lightbox-image"
                        data-fancybox="gallery"
                      >
                        <img
                          src={`./../../images/products/${item?.name
                            .replace(/\//g, "-")
                            .replace(/\*/g, "-")}.jpg`}
                          alt={item?.name}
                          onError={(e) => {
                            // Try JPEG format if JPG fails
                            if (e.target.src.endsWith(".jpg")) {
                              e.target.src = e.target.src.replace(
                                ".jpg",
                                ".jpeg"
                              );
                            } else {
                              e.target.src =
                                "./../../images/products/placeholder.svg";
                              e.target.alt = "Image not available";
                            }
                          }}
                        />
                      </a>
                    </figure>
                    <div className="slider-pager">
                      <ul className="thumb-box">
                        <li>
                          {" "}
                          <a className="active" data-slide-index="0" href="#">
                            <figure>
                              <img
                                src={`./../../images/products/${item?.name
                                  .replace(/\//g, "-")
                                  .replace(/\*/g, "-")}.jpg`}
                                alt={item?.name}
                                onError={(e) => {
                                  // Try JPEG format if JPG fails
                                  if (e.target.src.endsWith(".jpg")) {
                                    e.target.src = e.target.src.replace(
                                      ".jpg",
                                      ".jpeg"
                                    );
                                  } else {
                                    e.target.src =
                                      "./../../images/products/placeholder.svg";
                                    e.target.alt = "Image not available";
                                  }
                                }}
                              />
                            </figure>
                          </a>{" "}
                        </li>
                        <li>
                          {" "}
                          <a data-slide-index="1" href="#">
                            <figure>
                              <img
                                src="images/resource/products/product-details2.jpg"
                                alt=""
                              />
                            </figure>
                          </a>{" "}
                        </li>
                        <li>
                          {" "}
                          <a data-slide-index="2" href="#">
                            <figure>
                              <img
                                src="images/resource/products/product-details3.jpg"
                                alt=""
                              />
                            </figure>
                          </a>{" "}
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* <div className='slider-content'>
                    <figure className='image-box'>
                      <a
                        href='images/resource/products/product-details2.jpg'
                        className='lightbox-image'
                        data-fancybox='gallery'
                      >
                        <img
                          src='images/resource/products/product-details2.jpg'
                          alt=''
                        />
                      </a>
                    </figure>
                    <div className='slider-pager'>
                      <ul className='thumb-box'>
                        <li>
                          {' '}
                          <a className='active' data-slide-index='0' href='#'>
                            <figure>
                              <img
                                src='images/resource/products/product-details.jpg'
                                alt=''
                              />
                            </figure>
                          </a>{' '}
                        </li>
                        <li>
                          {' '}
                          <a data-slide-index='1' href='#'>
                            <figure>
                              <img
                                src='images/resource/products/product-details2.jpg'
                                alt=''
                              />
                            </figure>
                          </a>{' '}
                        </li>
                        <li>
                          {' '}
                          <a data-slide-index='2' href='#'>
                            <figure>
                              <img
                                src='images/resource/products/product-details3.jpg'
                                alt=''
                              />
                            </figure>
                          </a>{' '}
                        </li>
                      </ul>
                    </div>
                  </div> */}
                  {/* <div className='slider-content'>
                    <figure className='image-box'>
                      <a
                        href='images/resource/products/product-details3.jpg'
                        className='lightbox-image'
                        data-fancybox='gallery'
                      >
                        <img
                          src='images/resource/products/product-details3.jpg'
                          alt=''
                        />
                      </a>
                    </figure>
                    <div className='slider-pager'>
                      <ul className='thumb-box'>
                        <li>
                          {' '}
                          <a className='active' data-slide-index='0' href='#'>
                            <figure>
                              <img
                                src='images/resource/products/product-details.jpg'
                                alt=''
                              />
                            </figure>
                          </a>{' '}
                        </li>
                        <li>
                          {' '}
                          <a data-slide-index='1' href='#'>
                            <figure>
                              <img
                                src='images/resource/products/product-details2.jpg'
                                alt=''
                              />
                            </figure>
                          </a>{' '}
                        </li>
                        <li>
                          {' '}
                          <a data-slide-index='2' href='#'>
                            <figure>
                              <img
                                src='images/resource/products/product-details3.jpg'
                                alt=''
                              />
                            </figure>
                          </a>{' '}
                        </li>
                      </ul>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-6 col-xl-6 product-info">
                <div className="product-details__top">
                  <p className="product-details__content-text1">
                    <Link to={`/brands/${brandName}`}>{brandName}</Link>
                  </p>
                  <h3 className="product-details__title">{itemName}</h3>
                </div>
                <div className="product-details__reveiw"></div>
                <div className="product-details__content">
                  <p className="product-details__content-text1">
                    {item?.description}
                  </p>
                  {/* <p className='product-details__content-text2'>
                    <strong>REF.</strong> 4231/406 <br />
                    Available in store
                  </p> */}
                </div>

                <div className="product-details__quantity">
                  <h3 className="product-details__quantity-title">
                    Choose quantity
                  </h3>
                  {/* <!--Quantity Box--> */}
                  {!isService && (
                    <div className="quantity-box">
                      <button
                        type="button"
                        className="sub"
                        onClick={() => {
                          setQuantity((prev) => Math.max(0, prev - 1));
                        }}
                      >
                        <i className="fa fa-minus"></i>
                      </button>
                      <input
                        type="number"
                        value={quantity}
                        onChange={(e) =>
                          setQuantity(parseInt(e.target.value) || 0)
                        }
                      />
                      <button
                        type="button"
                        className="add"
                        onClick={() => {
                          setQuantity((prev) => prev + 1);
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </div>
                  )}
                </div>

                <div className="product-details__buttons">
                  <div className="product-details__buttons-1">
                    <span
                      className="theme-btn btn-style-one"
                      onClick={() => {
                        addToEnquiryList();
                      }}
                    >
                      <span className="btn-title">Add to Enquiry List</span>
                    </span>
                  </div>
                </div>
                <div className="product-details__buttons">
                  <Link to={"/cart"}>
                    <div className="product-details__buttons-1">
                      <span className="theme-btn btn-style-one">
                        <span className="btn-title">View Enquiry List</span>
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--Product Details End--> */}

        {/* <!--Product Leaflet Start--> */}
        <section className="product-description">
          <div className="container pt-0 pb-90">
            <div className="product-discription">
              <div className="tabs-box">
                {item?.datasheet_url ? (
                  <a
                    href={item.datasheet_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tab-btn active-btn"
                    style={{
                      textDecoration: "none",
                      color: "white",
                      backgroundColor: "#222429",
                      borderRadius: "0px",
                      border: "none",
                      padding: "14px 30px",
                      zIndex: "999",
                      position: "relative",
                    }}
                  >
                    VIEW DATA SHEET
                  </a>
                ) : (
                  <p className="product-description__text1">
                    No data available
                  </p>
                )}
              </div>
            </div>
          </div>
        </section>
        {/* <!--Product Leaflet End--> */}

        {/* <!--Product Description Start--> */}
        {/* <section className='product-description'>
          <div className='container pt-0 pb-90'>
            <div className='product-discription'>
              <div className='tabs-box'>
                <div className='tab-btn-box text-center'>
                  <ul className='tab-btns tab-buttons clearfix'>
                    <li className='tab-btn active-btn' data-tab='#tab-1'>
                      Description
                    </li>
                  </ul>
                </div>
                <div className='tabs-content'>
                  <div className='tab active-tab' id='tab-1'>
                    <div className='text'>
                      <p className='product-description__text1'>
                        Lorem ipsum dolor sit amet, cibo mundi ea duo, vim
                        exerci phaedrum. There are many variations of passages
                        of Lorem Ipsum available, but the majority have
                        alteration in some injected or words which don't look
                        even slightly believable. If you are going to use a
                        passage of Lorem Ipsum, you need to be sure there isn't
                        anything embarrang hidden in the middle of text.
                      </p>
                      <div className='product-description__list'>
                        <ul className='list-unstyled'>
                          <li>
                            <p>
                              <span className='fa fa-arrow-right'></span> Nam at
                              elit nec neque suscipit gravida.
                            </p>
                          </li>
                          <li>
                            <p>
                              <span className='fa fa-arrow-right'></span> Aenean
                              egestas orci eu maximus tincidunt.
                            </p>
                          </li>
                          <li>
                            <p>
                              <span className='fa fa-arrow-right'></span>{' '}
                              Curabitur vel turpis id tellus cursus laoreet.
                            </p>
                          </li>
                        </ul>
                      </div>
                      <p className='product-description__tex2'>
                        All the Lorem Ipsum generators on the Internet tend to
                        repeat predefined chunks as necessary, making this the
                        first true generator on the Internet. It uses a
                        dictionary of over 200 Latin words, combined with a
                        handful of model sentence structures, to generate Lorem
                        Ipsum which looks reasonable.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <!--Product Description End--> */}
        <Footer />
      </div>
      {/* <!-- Scroll To Top --> */}
      <div className="scroll-to-top scroll-to-target" data-target="html">
        <span className="fa fa-angle-up"></span>
      </div>
    </>
  );
};

export default ProductDetailsPage;
